import React, { useState } from 'react';
import AllFilterButton from '../AllFilterButton/AllFilterButton';
import { ReactComponent as Chevron } from '../../../../../../../../assets/icons/chevron.svg';
import styles from './AllFilterCategory.module.scss';
import { useResultListContext } from 'common/contexts/ResultListContext';

interface AllFilterCategoryProps {
  category: string;
  filters: { [key: string]: string };
  onFilterChange: (filterId: string) => void;
}

const AllFilterCategory: React.FC<AllFilterCategoryProps> = ({
  category,
  filters,
  onFilterChange,
}) => {
  const [isFilterVisible, setIsFilterVisible] = useState(false);

  const filterIds = Object.keys(filters);

  const [filteredFilterIds, setFilteredFilterIds] = useState<string[]>([]);
  const { activeFilters, availableAmenities } = useResultListContext();

  const toggleFilterVisibility = () => {
    setIsFilterVisible((prevIsFilterVisible) => !prevIsFilterVisible);
  };

  const countActiveFiltersInCategory = () => {
    let count = 0;
    for (const id of filterIds) {
      if (activeFilters[id]) {
        count++;
      }
    }
    return count;
  };

  React.useEffect(() => {
    const newFilteredFilterIds = filterIds.filter(id => availableAmenities[id]);
    console.log(availableAmenities);
    if (!arraysAreEqual(newFilteredFilterIds, filteredFilterIds)) {
      setFilteredFilterIds(newFilteredFilterIds);
    }
  }, [filterIds, availableAmenities, filteredFilterIds]);
  
  function arraysAreEqual(arr1:string[], arr2:string[]) {
    return arr1.length === arr2.length && arr1.every((value, index) => value === arr2[index]);
  }

  return (
    filteredFilterIds.length > 0 ? (
      <div className={styles.filter__category}>
      <div className={styles.heading} onClick={toggleFilterVisibility}>
        <div className={styles.toggle}>
          {category} 
          {
            countActiveFiltersInCategory() > 0 && (
              <div className={styles.active_values}>{countActiveFiltersInCategory()}</div>
            )
          }
        </div>
        <Chevron style={{ transform: !isFilterVisible ? 'rotate(270deg)' : 'none' }} />
      </div>
      {isFilterVisible && (
        <div className={styles.filter__category__buttons}>
          {filteredFilterIds.map((id) => (
            <AllFilterButton
              key={id}
              active={activeFilters[id]}
              id={id}
              label={filters[id]}
              onClick={onFilterChange}
            />
          ))}
        </div>
      )}
    </div>
    ) : null
  );
};

export default AllFilterCategory;
